import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import EventDetailComponent from 'components/EventDetail';
import { requestEventDetail, unsetEventDetail } from './actions';
import { setCommonPopup } from 'containers/Popup/actions';
import PopupChooseStudent from '../PopupChooseStudent';
import PopupViewStudentProfile from './PopupViewStudentProfile';
import './style.css';
import TriggerLogout from '../Account/TriggerLogout';
import { Helmet } from 'react-helmet';
import { getSeoDataByEventIdRequest } from '../Seo/actions';
import queryString from 'query-string';
import { get, isEmpty } from 'lodash';
import { getOfferEventDetailRequest } from 'containers/OfferEventRequestModal/actions';

class EventDetail extends Component {
  fetchEventData = () => {
    const { eventId } = this.props.match.params;
    this.props.requestEventDetail(eventId);
  };

  componentDidMount = () => {
    this.fetchEventData();
    const { eventId } = this.props.match.params;

    this.props.getSeoDataByEventId(eventId);
  };

  componentDidUpdate(prevProps) {
    if (this.props.match.params !== prevProps.match.params) {
      this.fetchEventData();
      const { eventId } = this.props.match.params;
      this.props.getSeoDataByEventId(eventId);
    }
    const { needAcceptOffer } =
      queryString.parse(this.props.location.search) || {};
    if (
      needAcceptOffer === 'true' &&
      isEmpty(prevProps.eventInfo) &&
      !isEmpty(this.props.eventInfo) &&
      get(this.props, 'eventInfo.offerEvent') &&
      get(this.props, 'currentUser.role') === 'STUDENT'
    ) {
      const { eventId } = this.props.match.params;
      this.props.getOfferEventDetail({ eventId, reference: 'email' });
    }
  }

  afterLogout = (res) => {
    let userRole = get(res, 'data.role', '').toLowerCase();
  
    this.fetchEventData();
  
    // Direct to login form
    userRole = userRole && `${userRole.charAt(0).toUpperCase()}${userRole.slice(1)}`;
    if (userRole) this.props.history.replace(`/login${userRole}`);
  };

  componentWillUnmount = () => {
    this.props.unsetEventDetail();
  };

  render() {
    const {
      eventInfo,
      currentUser,
      openPopupChooseStudent,
      openPopupViewStudentProfile,
      seo
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{seo.title}</title>
          <meta name="title" content={seo.title} />
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keyword} />
          <meta name="twitter:image" content={seo.image} />
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:image" content={seo.image} />
        </Helmet>

        <EventDetailComponent
          eventInfo={eventInfo}
          stateInfo={eventInfo.eventStateInfo}
          currentUser={currentUser}
          createdBy={eventInfo.createdBy}
          openPopupChooseStudent={openPopupChooseStudent}
          openPopupViewStudentProfile={(index, list, status) =>
            openPopupViewStudentProfile(index, list, status)
          }
        />
        <TriggerLogout afterLogout={this.afterLogout} />
        <PopupChooseStudent />
        <PopupViewStudentProfile
          eventId={eventInfo.objectId}
          openPopupChooseStudent={this.props.openPopupChooseStudent}
        />
      </Fragment>
    );
  }
}

EventDetail.propTypes = {
  eventInfo: PropTypes.object.isRequired,
  match: PropTypes.any,
  location: PropTypes.object,
  history: PropTypes.any,
  requestEventDetail: PropTypes.func,
  currentUser: PropTypes.object,
  seo: PropTypes.object,
  getSeoDataByEventId: PropTypes.func,
  openPopupChooseStudent: PropTypes.func,
  openPopupViewStudentProfile: PropTypes.func,
  unsetEventDetail: PropTypes.func,
  getOfferEventDetail: PropTypes.func
};

EventDetail.defaultProps = {
  eventInfo: {}
};

const mapStateToProps = (state) => {
  return {
    seo: state.get('seo'),
    eventInfo: state.get('eventDetail').get('eventInfo'),
    currentUser: state.get('account').get('data')
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSeoDataByEventId: (objectId) =>
    dispatch(getSeoDataByEventIdRequest(objectId)),
  getOfferEventDetail: ({ eventId, reference }) =>
    dispatch(getOfferEventDetailRequest({ eventId, reference })),
  requestEventDetail: (eventId) => dispatch(requestEventDetail(eventId)),
  openPopupChooseStudent: (type, eventId, userId) =>
    dispatch(setCommonPopup('chooseStudent', { type, eventId, userId })),
  openPopupViewStudentProfile: (index, list, status) =>
    dispatch(setCommonPopup('studentProfile', { index, list, status })),
  unsetEventDetail: () => dispatch(unsetEventDetail())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withImmutablePropsToJS(EventDetail));
